import React from "react";
import "./ContentWrapper.scss";

export const CONTENT_WRAPPER_TYPE = {
  CARD: 'card',
  NORMAL: 'normal'
}

export const ContentWrapper = ({ type = CONTENT_WRAPPER_TYPE.NORMAL, style, titleStyle, text = "" }) => {
  
  const isTypeCard = type === CONTENT_WRAPPER_TYPE.CARD;
  const isTypeNormal = type === CONTENT_WRAPPER_TYPE.NORMAL;
  
  return (
    <div
      className={`content-wrapper-type-card ${
        isTypeCard ? "content-wrapper-Card-type-card" : "content-wrapper-class-2"
      }`}
      style={style}
    >
      <div className={`content-wrapper-card ${isTypeCard ? "content-wrapper-Card" : "content-wrapper-class"}`}>
        <React.Fragment>
          {isTypeCard && (
            <React.Fragment>
              <div
                className={"content-wrapper-card-content"}
                style={{
                  backgroundImage: "url(/img/screenshot-2023-03-02-at-01-09-1-1.png)",
                }}
              />
              <div className={"content-wrapper-title"}>{text}</div>
            </React.Fragment>
          )}

          {isTypeNormal && (
            <React.Fragment>
              <div className={"content-wrapper-title-371-165544"} style={titleStyle}>
                {text}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    </div>
  );
};